import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAssetRepeatAppIconSmallOl = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: .5,
		y: .5,
		width: 31,
		height: 31,
		rx: 7.5,
		fill: "#091F24",
		stroke: "#091F24"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M20.6642 21.193L23.4631 23.9997H15.8787V16.3964L18.6957 19.2196L19.7624 18.1498C21.6075 16.0705 22.049 14.7242 21.3825 13.1873C20.7524 11.735 19.2724 10.7947 17.6102 10.7947H11.7877V24H9V8H17.6105C20.3874 8 22.8682 9.60139 23.941 12.0771C25.5677 15.8343 22.9387 18.782 21.8189 20.041L20.6642 21.193Z",
		fill: "white"
	})]
});
export default SvgAssetRepeatAppIconSmallOl;
